// import React from "react";

// // This is For Downloading Questionaires

// const QuestionaireDownload = ({ text }) => {
//   // Download SOP Questionnaire
//   return (
//     <>
//       {/* Download LOR Questionnaire Section */}
//       <div className="flex justify-between items-center bg-purple-800 text-white px-4 py-3 ">
//         <h2 className="text-lg font-semibold">{text}</h2>
//         <button className="bg-white text-purple-700 px-4 py-2 rounded hover:bg-purple-100 transition">
//           <svg
//             className="w-5 h-5 inline-block mr-2"
//             fill="currentColor"
//             viewBox="0 0 20 20"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path d="M10 2a1 1 0 00-1 1v8H5l5 5 5-5h-4V3a1 1 0 00-1-1z" />
//           </svg>
//           Download
//         </button>
//       </div>
//       <div className=""></div>
//     </>
//   );
// };

// export default QuestionaireDownload;

const QuestionaireDownload = ({
  text,
  selectedCategory,
  setSelectedCategory,
  handleDownload,
  studentLevels = [],
}) => {
  return (
    <div className="flex justify-between items-center bg-purple-800 text-white px-4 py-3">
      <div>
        <h2 className="text-lg font-semibold mb-1">{text}</h2>
      </div>
      <div className="flex space-x-2">
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="text-black p-2 rounded"
        >
          <option value="">Select Category</option>
          {studentLevels.map((level, index) => (
            <option key={index} value={level}>
              {level}
            </option>
          ))}
        </select>
        <button
          onClick={handleDownload}
          disabled={!selectedCategory}
          className={`bg-white text-purple-700 px-4 py-2 rounded hover:bg-purple-100 transition ${
            !selectedCategory ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <svg
            className="w-5 h-5 inline-block mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 2a1 1 0 00-1 1v8H5l5 5 5-5h-4V3a1 1 0 00-1-1z" />
          </svg>
          Download
        </button>
      </div>
    </div>
  );
};

export default QuestionaireDownload;
